import React from "react";
import { Link } from "react-router-dom";
import BlogImage from "./BlogImage";
import { excerpt, formatBlogDate, readingTime } from "./blogUtils";
import "./BlogCard.css";

const IcoClock = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const IcoArrow = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const BlogCard = ({ blog, featured = false }) => {
  if (!blog) return null;

  const date = formatBlogDate(blog.publish_date || blog.created_date);
  const minutes = readingTime(blog.long_description || blog.short_description);
  const summary = excerpt(blog.short_description, featured ? 230 : 140);

  return (
    <article className={featured ? "blog-card blog-card--featured" : "blog-card"}>
      <Link to={`/blog/${blog.slug}`} className="blog-card-media" tabIndex={-1} aria-hidden="true">
        <BlogImage
          src={blog.thumb_image_url}
          alt={blog.thumb_image_alt || blog.title || "Blog image"}
          className="blog-card-img"
          eager={featured}
        />
        {blog.category_name && (
          <span className="blog-card-badge">{blog.category_name}</span>
        )}
      </Link>

      <div className="blog-card-body">
        <h3 className="blog-card-title">
          <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
        </h3>

        {summary && <p className="blog-card-excerpt">{summary}</p>}

        <div className="blog-card-foot">
          <div className="blog-card-meta">
            {date && <span>{date}</span>}
            {date && <span className="blog-card-dot" aria-hidden="true" />}
            <span className="blog-card-read">
              <IcoClock /> {minutes} min read
            </span>
          </div>
          <Link to={`/blog/${blog.slug}`} className="blog-card-link">
            Read more <IcoArrow />
          </Link>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;
